import React, { Component} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import Link from "@amzn/meridian/link";
import Loader from "@amzn/meridian/loader";
import {getChildContainerHistoryForParentContainer} from "../../../commons/api/GetChildContainerHistoryForParentContainerResult.js";
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Icon from "@amzn/meridian/icon";
import Toaster from "@amzn/meridian/toaster"
import Alert from "@amzn/meridian/alert"
import { validateEmail, oldTimeZoneMapper, handleBlankValue } from "../../../commons/CommonUtils.js";
import { FormattedMessage, injectIntl } from "react-intl";

class ChildContainerView extends Component {

    constructor(props) {
        super(props)
        this.state = {
          isLoading : true,
          previousPageTokens: [null],
          nextPageToken: null,
          toasters: []
        }
        this.setUpdated = props.setUpdated.bind(this)
    }

    getPageSize() {
        return 100
    }

    searchPath = "#/detailPage/";

    searchContainerRequestOption = {
        "type": "CONTAINER",
        "startDate": this.props.startDate,
        "endDate": this.props.endDate
    }

    fetchAssociate = (lastProcessedByAssociateName) => {
        return lastProcessedByAssociateName ?
        (validateEmail(lastProcessedByAssociateName) ? 
        (<Link href = {this.searchPath.concat(lastProcessedByAssociateName).concat("/" + JSON.stringify(this.searchAssociateRequestOption))}>{lastProcessedByAssociateName}</Link>)
        : lastProcessedByAssociateName
        )
        : '';
    }
 
    async nextButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });
        if (this.state.childContainerHistory.length < this.getPageSize()) {
            this.setState({
                isLoading: false,
                toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
            });
        } else {

            let childContainerHistoryData = await getChildContainerHistoryForParentContainer(this.props.parentContainerLabel,
                this.props.nodeId, this.getPageSize(), this.state.nextPageToken, this.props.startDate, this.props.endDate);
            this.setUpdated({})

            if (childContainerHistoryData.childContainerHistory.length > 0) {
                this.setState({
                    isLoading: false,
                    previousPageTokens: this.state.previousPageTokens.concat([this.state.nextPageToken]),
                    childContainerHistory : childContainerHistoryData.childContainerHistory,
                    nextPageToken : childContainerHistoryData.nextPageToken
                });
            } else {
                this.setState({
                    isLoading: false,
                    toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
                });
            }
        }
    }

    async previousButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });

        let newPreviousPageTokens = this.state.previousPageTokens.slice(0, -1);
        let prevPageToken = newPreviousPageTokens.slice(-1).pop();

        let childContainerHistoryData = await getChildContainerHistoryForParentContainer(this.props.parentContainerLabel,
            this.props.nodeId, this.getPageSize(), prevPageToken, this.props.startDate, this.props.endDate);
        this.setUpdated({})
       
       if (childContainerHistoryData.childContainerHistory.length > 0) {
           this.setState({
               isLoading: false,
               previousPageTokens: newPreviousPageTokens,
               childContainerHistory : childContainerHistoryData.childContainerHistory,
               nextPageToken : childContainerHistoryData.nextPageToken
           });
       } else {
           this.setState({
               isLoading: false,
               toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_previous_entry'}), timeout: 3000}]
           });
       }
    }

    async componentDidMount() {
        let childContainerHistoryData = await getChildContainerHistoryForParentContainer(this.props.parentContainerLabel,
            this.props.nodeId, this.getPageSize(), null, this.props.startDate, this.props.endDate);
        this.setUpdated({})
        this.setState({
            isLoading : false,
            childContainerHistory : childContainerHistoryData.childContainerHistory ? childContainerHistoryData.childContainerHistory : [],
            nextPageToken : childContainerHistoryData.nextPageToken,
            previousPageToken : this.state.previousPageTokens.concat([this.state.nextPageToken])
        })
    }

    render() {
        return this.state.isLoading ? <Row spacingInset="large" widths={["grid-2"]}><Column/><Loader/></Row> : this.renderHistoryTable();
    }

    renderHistoryTable() {
        return (
            <React.Fragment>
                <Toaster toasts={this.state.toasters} onCloseToast={() => {this.setState({toasters: []})}} alignmentHorizontal="center">
                    {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                </Toaster>
                <Column spacingInline="large large none large">
                    <Row widths={["grid-12"]} spacingInset="none">
                        <div style={{"overflowX": "scroll"}}>
                            <Table showDividers={false} spacing="small">
                            <TableRow>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.childContainer_id" defaultMessage="ID"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.childContainer_type" defaultMessage="Type"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.childContainer_dateAdded" defaultMessage="Date Added"/></Text></TableCell>
                                <TableCell width={120}><Text type="h100"><FormattedMessage id="search.container.childContainer_associate" defaultMessage="Associate"/></Text></TableCell>
                            </TableRow>
                            { this.state.childContainerHistory && this.state.childContainerHistory.map(history => {
                                let searchPath = "#" + this.props.previousPath + "/";
                                let dateAdded = new Date(history.dateAdded).toLocaleString('en-US', {timeZone: this.props.stationTimeZone ? oldTimeZoneMapper(this.props.stationTimeZone) : undefined});
                                return <TableRow>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} ><Link href = {searchPath.concat(history.childContainerLabel).concat("/" + JSON.stringify(this.searchContainerRequestOption))}>{history.childContainerLabel}</Link></div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.childContainerType)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(dateAdded)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchAssociate(handleBlankValue(history.associateName))}</div></TableCell>                              
                            </TableRow>   
                            })}  
                            </Table>
                        </div>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} spacingInset="none">
                        <Button type="link" onClick={this.previousButtonClick.bind(this)} disabled={this.state.previousPageTokens.length <= 1}><Icon tokens={chevronLeftLargeTokens} /></Button>
                        <Button type="link" onClick={this.nextButtonClick.bind(this)}><Icon tokens={chevronRightLargeTokens} /></Button>
                    </Row>  
                </Column> 
            </React.Fragment>       
        )
    }
}




export default injectIntl(ChildContainerView);




// WEBPACK FOOTER //
// ./src/components/detailPages/containerDetails/ChildContainerView.js